import React from 'react';
import { injectIntl } from 'react-intl';
import AdobeEmbedPdfViewer from './AdobeEmbedPdfViewer';

class EmbeddableDocumentViewer extends React.Component {
  pdfViewerRef = null;

  constructor(props) {
    super(props);
    this.pdfViewerRef = React.createRef();
  }

  componentDidMount() {
    if (this.pdfViewerRef?.current) {
      this.loadPDF();
    }
  }

  loadPDF = () => {
    const { filePath, fileName, intl } = this.props;

    const viewer = new AdobeEmbedPdfViewer();
    viewer.ready().then(() => {
      viewer.previewFile(
        'adobe-dc-view',
        {
          showPrintPDF: true,
          showZoomControl: true,
          showAnnotationTools: false,
          showLeftHandPanel: false,
          showPageControls: false,
          showDownloadPDF: false,
          enableFormFilling: false,
          showThumbnails: false,
          embedMode: 'FULL_WINDOW',
          defaultViewMode: 'FIT_WIDTH',
        },
        filePath,
        fileName,
        intl.locale,
      );
    });
  };

  render() {
    const { filePath, mimeType, storageType } = this.props;
    const isPdf = mimeType === 'application/pdf';

    return isPdf ? (
      <div id="adobe-dc-view" ref={this.pdfViewerRef} />
    ) : (
      <iframe
        title="Preview"
        style={{ height: '100%', width: '100%' }}
        src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(filePath)}`}
      />
    );
  }
}
export default injectIntl(EmbeddableDocumentViewer);
